export default "assets/images/icons/fleche-d2f88b38.svg";